export default __webpack_public_path__ + "8d9ec481c95f5372c90152d5e74a6eb3.png";